export const VISUAL_NODE_TYPE = "visual-node";
export function isVisualNode(what) {
    return what.type.includes(VISUAL_NODE_TYPE);
}
//# sourceMappingURL=visual-node.js.map